var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMdt(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "m15.614 2 .359.197 9.201 5.06-.71 1.29-8.11-4.46v6.024a.736.736 0 1 1-1.472.001v-6.01L6.96 8.544 6.24 7.26l9.018-5.06.356-.2zm-8.383 8 7.165 4.02a2.29 2.29 0 0 1 1.315-.412c.464 0 .897.137 1.258.374l7.327-3.99 1.232 2.263-7.564 4.119a2.3 2.3 0 0 1-4.487.085L5.97 12.246 7.231 10zM6.155 24.742l9.201 5.06.359.198.356-.2 9.018-5.06-.72-1.285-8.014 4.497v-5.787a.736.736 0 0 0-1.472 0v5.697l-8.019-4.41-.71 1.29zM4.3 11.952a2.3 2.3 0 1 0 0-4.601 2.3 2.3 0 0 0 0 4.601zm22.82 0a2.3 2.3 0 1 0 0-4.601 2.3 2.3 0 0 0 0 4.601zM6.6 22.348a2.3 2.3 0 1 1-4.6 0 2.3 2.3 0 0 1 4.6-.001zm20.52 2.3a2.3 2.3 0 1 0 0-4.601 2.3 2.3 0 0 0 0 4.6zM5.497 12.595v6.9H2.92v-6.9h2.577zm23.003 6.9v-6.9h-2.576v6.9H28.5z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMdt);
export default __webpack_public_path__ + "static/media/MDT.6a9cc24775b116b2cdaf9e693c3d983d.svg";
export { ForwardRef as ReactComponent };